var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FBFCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.72007 7.72C7.86069 7.57955 8.05132 7.50066 8.25007 7.50066C8.44882 7.50066 8.63944 7.57955 8.78007 7.72L12.0001 10.94L15.2201 7.72C15.2888 7.64631 15.3716 7.58721 15.4636 7.54622C15.5556 7.50523 15.6549 7.48319 15.7556 7.48141C15.8563 7.47963 15.9563 7.49816 16.0497 7.53588C16.1431 7.5736 16.2279 7.62974 16.2991 7.70096C16.3704 7.77218 16.4265 7.85702 16.4642 7.9504C16.5019 8.04379 16.5205 8.14382 16.5187 8.24452C16.5169 8.34523 16.4949 8.44454 16.4539 8.53654C16.4129 8.62854 16.3538 8.71134 16.2801 8.78L13.0601 12L16.2801 15.22C16.3538 15.2887 16.4129 15.3715 16.4539 15.4635C16.4949 15.5555 16.5169 15.6548 16.5187 15.7555C16.5205 15.8562 16.5019 15.9562 16.4642 16.0496C16.4265 16.143 16.3704 16.2278 16.2991 16.299C16.2279 16.3703 16.1431 16.4264 16.0497 16.4641C15.9563 16.5018 15.8563 16.5204 15.7556 16.5186C15.6549 16.5168 15.5556 16.4948 15.4636 16.4538C15.3716 16.4128 15.2888 16.3537 15.2201 16.28L12.0001 13.06L8.78007 16.28C8.63789 16.4125 8.44984 16.4846 8.25554 16.4812C8.06124 16.4777 7.87586 16.399 7.73844 16.2616C7.60103 16.1242 7.52232 15.9388 7.51889 15.7445C7.51546 15.5502 7.58759 15.3622 7.72007 15.22L10.9401 12L7.72007 8.78C7.57962 8.63938 7.50073 8.44875 7.50073 8.25C7.50073 8.05125 7.57962 7.86063 7.72007 7.72Z",
    fill: "#647593"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1cccc5b34f9ac315f9752332f53c881c.svg";
export { ForwardRef as ReactComponent };